/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import style from './pictures.module.scss';

interface PictureIntereface {
  photoOne: string | null;
  photoTwo?: string | null;
  photoThree?: string | null;
}

const Pictures: React.FC<PictureIntereface> = ({
  photoOne,
  photoTwo,
  photoThree,
}) => {
  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 800 }),
  };

  const shellStyle = resolution.DesktopOrLaptop
    ? style.sDesktop
    : style.sMobile;
  const gridPhotoStyle = resolution.DesktopOrLaptop
    ? style.rDesktop
    : style.rMobile;

  return (
    <div className={shellStyle}>
      {photoOne ? (
        <img src={photoOne} className={style.pic} alt="pic1" />
      ) : (
        <div className={style.noPic}>
          <h2 className={`${style.noPicText} h2`}>Нет изображения</h2>
        </div>
      )}
      <div className={gridPhotoStyle}>
        {photoTwo ? (
          <img src={photoTwo} className={style.pic} alt="pic2" />
        ) : null}
        {photoThree ? (
          <img src={photoThree} className={style.pic} alt="pic3" />
        ) : null}
      </div>
    </div>
  );
};

export default Pictures;
